import html2canvas from "html2canvas";
import { useEffect, useState } from "react";

export default function CaptureGeolocation({ formik, setSelectedFiles }) { // Removi serviceType pois não é mais necessário
    const [loadingCoords, setLoadingCoords] = useState(false);
    const [coords, setCoords] = useState(null);
    const [copied, setCopied] = useState(false);

    // Extrai coordenadas do link_maps se existir
    useEffect(() => {
        const link = formik.values.attributes?.link_maps;
        if (link && link.includes("maps.google.com")) {
            const match = link.match(/q=([-.\d]+),([-.\d]+)/);
            if (match) {
                const latitude = parseFloat(match[1]);
                const longitude = parseFloat(match[2]);
                setCoords({ latitude, longitude });
            }
        }
    }, [formik.values.attributes?.link_maps]);

    const capturarLocalizacao = () => {
        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo navegador.");
            return;
        }

        setLoadingCoords(true);
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                const link = `https://maps.google.com/?q=${latitude},${longitude}`;
                formik.setFieldValue(`text___attributes.link_maps`, link);
                setCoords({ latitude, longitude });
                setCopied(false);
                setLoadingCoords(false);
            },
            (error) => {
                console.error("Erro ao obter localização:", error);
                alert("Não foi possível capturar a localização.");
                setLoadingCoords(false);
            }
        );
    };

    const copiarParaClipboard = async () => {
        if (!coords) return;

        try {
            const localDiv = document.getElementById("localizacao");
            if (!localDiv) return;

            // 1. Captura da imagem com html2canvas
            const canvas = await html2canvas(localDiv);
            const blob = await new Promise((resolve) =>
                canvas.toBlob((blob) => resolve(blob), "image/png")
            );

            // 2. Converte blob para File
            const file = new File([blob], "localizacao.png", { type: "image/png" });

            // 3. Anexa ao selectedFiles
            if (setSelectedFiles) {
                setSelectedFiles((prev) => [...prev, file]);
            }
            // Formata as coordenadas substituindo ponto por vírgula
            const coordenadasFormatadas =
                `Lat: ${coords.latitude.toString().replace('.', ',')}   Lon: ` +
                `${coords.longitude.toString().replace('.', ',')}`;

            await navigator.clipboard.writeText(coordenadasFormatadas);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Erro ao copiar:", err);
        }
    };

    // Não precisa mais do showLocationButton, a verificação será feita no componente pai
    return (
        <div id="localizacao" className="p-3" >
            <div className="space-y-4 w-full text-center">
                {/* Mapa embed */}
                {coords && (
                    <iframe
                        title="Mapa"
                        width="100%"
                        height="300"
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        className="rounded-lg border"
                        src={`https://maps.google.com/maps?q=${coords.latitude},${coords.longitude}&z=15&output=embed`}
                    ></iframe>
                )}

                {/* Botão de captura */}
                <button
                    type="button"
                    onClick={capturarLocalizacao}
                    disabled={loadingCoords}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                    {loadingCoords ? "Capturando localização..." : "Capturar Localização"}
                </button>

                {/* Coordenadas e botão copiar */}
                {coords && (
                    <div className="text-sm text-gray-700 space-y-2">
                        <p>
                            Coordenadas:{" "}
                            <strong>
                                {coords.latitude.toFixed(6)}, {coords.longitude.toFixed(6)}
                            </strong>
                        </p>

                        <div className="flex justify-center items-center space-x-2">
                            <button
                                type="button"
                                onClick={copiarParaClipboard}
                                className="bg-gray-200 hover:bg-gray-300 text-sm px-3 py-1 rounded"
                            >
                                📋 Copiar Coordenadas
                            </button>
                            {copied && <span className="text-green-600 text-sm">Copiado!</span>}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}